import React from 'react';
import './Ayuda.css';

const ESPECIALIDADES = [
  'Descenso de grasa corporal',
  'Fertilidad y búsqueda de embarazo',
  'Embarazo y posparto',
  'Salud digestiva',
  'Resistencia a la insulina',
  'SOP y salud hormonal',
  'Alimentación antiinflamatoria',
  'Organización de comidas',
];

const Ayuda = () => (
  <section className="ayuda-section">
    <div className="ayuda-inner">
      <p className="ayuda-label">Especialidades</p>
      <h2 className="ayuda-title">¿En qué puedo <span className="deco-underline">ayudarte</span>?</h2>
      <div className="ayuda-grid">
        {ESPECIALIDADES.map((item) => (
          <div key={item} className="ayuda-item">
            <span className="ayuda-dot" aria-hidden="true"></span>
            {item}
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Ayuda;
